module.exports = __webpack_public_path__ + "media/src/images/businessStats2-13bf64548288cdfdc5886f2632deab3d.svg";